import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button } from 'react-bootstrap';
import BackIcon from '../../../../styles/images/back-without-bg.png';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { handleChangeDataBottomSheet } from '../../../../redux/actions/partials/footer/bottom_sheet';
import { handleChangeInstallmentsUploadFactorPage } from '../../../../redux/actions/pages/installments/upload_factor';
import { BASE_SITE, UPLOAD_FACTOR } from '../../../../apis'; 
import imageCompression from 'browser-image-compression';

const UploadFactor = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.user);
    const { branchId, shopTitle, branchTitle, services, serviceSelected, amount, file, disableBtn, btnClass } = useSelector(state => state.installmentsUpload);
    const orgBuy = serviceSelected !== null ? services.filter(sService => sService.service === serviceSelected)[0].orgBuy : false;
    const credit = orgBuy ? (profile.user_credit + profile.user_org_credit) : profile.user_credit;

    

    useEffect(() => {
        dispatch(handleChangeInstallmentsUploadFactorPage('amount', ''));
        dispatch(handleChangeInstallmentsUploadFactorPage('file', false));
        // eslint-disable-next-line
    }, [UploadFactor]);

    useEffect(() => {
        if( parseInt(removeNonNumeric(amount)) > 0 && !!file && !!serviceSelected) {
            dispatch(handleChangeInstallmentsUploadFactorPage('disableBtn', false));
            dispatch(handleChangeInstallmentsUploadFactorPage('btnClass', ''));
        }
        else {
            dispatch(handleChangeInstallmentsUploadFactorPage('disableBtn', true));
            dispatch(handleChangeInstallmentsUploadFactorPage('btnClass', 'disable-btn'));
        }
        // eslint-disable-next-line
    }, [amount, file, serviceSelected]);

    const handleBackBtn = () => {
        navigate(-1);
    };



    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }


    const handelChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeInstallmentsUploadFactorPage(name, addCommas(removeNonNumeric(changeNumberPersianAndArabic(value))) ));
    };

    const handelChangeFile = async (event) => {
        // dispatch(handleChangeInstallmentsUploadFactorPage('file', event.target.files[0]));

        const selectedFile = event.target.files[0];
        if (!selectedFile) return;


        if (selectedFile.size > 200 * 1024) {
            const options = {
                maxSizeMB: 0.2, // فشرده‌سازی به حدود 200KB
                useWebWorker: true,
            };
            try {
                const compressedBlob = await imageCompression(selectedFile, options);
                const compressedFile = new File(
                    [compressedBlob],
                    selectedFile.name, // اینجا نام و پسوند اصلی حفظ می‌شه
                    { type: selectedFile.type }
                );
                dispatch(handleChangeInstallmentsUploadFactorPage('file', compressedFile));
            } catch (err) {
                dispatch(handleChangeInstallmentsUploadFactorPage('file', selectedFile));
            }
        } else {
            dispatch(handleChangeInstallmentsUploadFactorPage('file', selectedFile));
        }
    };

    const handleUploadBtn = async () => {
        if (!file) {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'لطفا تصویر فاکتور را انتخاب کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));  
            return;
        }
        if(removeNonNumeric(amount).length === 0 || removeNonNumeric(amount) === '') {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'مبلغ فاکتور را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));  
            return;
        }

        dispatch(handleSetBackdropLoading(true));
        dispatch(handleChangeInstallmentsUploadFactorPage('disableBtn', true));
        dispatch(handleChangeInstallmentsUploadFactorPage('btnClass', 'disable-btn'));


        const formData = new FormData();
        formData.append('image', file);
        formData.append('branch', branchId);
        formData.append('amount', removeNonNumeric(amount));
        formData.append('service', serviceSelected);

        try {
            dispatch(handleSetBackdropLoading(true));

            const response = await fetch(BASE_SITE + UPLOAD_FACTOR, {
                method: 'POST',
                headers: {
                    'Authorization': token, 
                },
                body: formData,
            });

            const result = await response.json();

            if(response.ok) {
                if(result.status === 'ok') {
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'تصویر مورد نظر با موفقیت آپلود شد', severity: 'success', vertical: 'top', horizontal: 'center'}));  
                    dispatch(handleChangeInstallmentsUploadFactorPage('disableBtn', true));
                    dispatch(handleChangeInstallmentsUploadFactorPage('btnClass', 'disable-btn'));
                    navigate('../..');
                }
                else if(result.status === 'error') {
                    dispatch(handleSetOpenCustomSnackbar(true, {message: result.message, severity: 'error', vertical: 'top', horizontal: 'center'}));  
                    dispatch(handleChangeInstallmentsUploadFactorPage('disableBtn', false));
                    dispatch(handleChangeInstallmentsUploadFactorPage('btnClass', ''));
                }
            }
            else {
                dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور.لطفا دقایقی دیگر تلاش کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));  
                dispatch(handleChangeInstallmentsUploadFactorPage('disableBtn', false));
                dispatch(handleChangeInstallmentsUploadFactorPage('btnClass', ''));
            }
            dispatch(handleSetBackdropLoading(false));
        } catch (err) {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور.لطفا دقایقی دیگر تلاش کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));  
            dispatch(handleSetBackdropLoading(false));
            dispatch(handleChangeInstallmentsUploadFactorPage('disableBtn', false));
            dispatch(handleChangeInstallmentsUploadFactorPage('btnClass', ''));
        } finally {
            dispatch(handleSetBackdropLoading(false));
            dispatch(handleChangeInstallmentsUploadFactorPage('disableBtn', false));
            dispatch(handleChangeInstallmentsUploadFactorPage('btnClass', ''));
        }

            
            
    };

    const closeBottomSheet = () => {
        dispatch(handleChangeDataBottomSheet('isOpen', false));
    };

    const handleRadioChange = (serviceId) => {
        dispatch(handleChangeInstallmentsUploadFactorPage('serviceSelected', serviceId));
    };

    return (

        <div id="edit-profile-page" onClick={closeBottomSheet} >

            <Row className="py-3 white-bg sticky top-0 z-index-2">
                <Col xs={1}><img src={BackIcon} alt="back" onClick={handleBackBtn} role="button" /></Col>
                <Col xs={10}><h4 className="text-center">آپلود فاکتور خرید</h4></Col>
                <Col xs={1}></Col>
            </Row>

            <div className="d-flex justify-content-start short-profile mt-4 p-4">
                <div className="d-flex flex-column justify-content-center">
                    <span className="phone-num">لطفا تصویر فاکتور خرید اقساطی از {shopTitle} {branchTitle} را آپلود کنید</span>
                </div>
            </div>

            <Row className="pb-5">
                <Col xs={12} className="mt-5">
                    <div className="input-wrapper" >
                        <label className="label-wrapper" htmlFor="input-amount" >مبلغ (ریال)</label>
                        <input type="text" name="amount" id="input-amount" value={amount} onChange={handelChangeInputs} className="custom-input w-100 px-3 custom-vertical-padding" />
                    </div>
                </Col>

                <Col xs={12} className="mt-3">
                    <div className="input-wrapper" >
                        <label className="label-wrapper" htmlFor="first" >انتخاب تصویر</label>
                        <input type="file" name="fname" onChange={handelChangeFile} accept="image/*" className="custom-input w-100 px-3 custom-vertical-padding" />
                    </div>
                </Col>

                

                <Col xs={12} className="text-center mt-2">
                    {file && file.type.startsWith('image/') && (
                        <img src={URL.createObjectURL(file)} alt="preview" height={100} />
                    )}
                </Col>

                <Col xs={12} className="mt-4">
                    <Button onClick={handleUploadBtn} className={`w-100 py-3 login-form-button ${btnClass}`} disabled={disableBtn}>
                        آپلود فاکتور
                    </Button>
                </Col>

                { services.length > 1 ?
                    <>
                        <Col xs={12} className="mt-3">نوع محصول  یا خدمات را انتخاب کنید</Col>
                        {
                            services.map((service, key) => {
                                return (
                                    <Col xs={12} className="mt-3" role="button" key={key}>
                                        <div className="col-service d-flex align-items-center">
                                            <label className="w-100 d-flex" role="button">
                                                <input
                                                    type="radio"
                                                    name="service"
                                                    value={service.service}
                                                    checked={serviceSelected === service.service ? true : false}
                                                    onChange={(e) => handleRadioChange(e.target.value)}
                                                    className='mr-2' />
                                                {service.title}
                                            </label>
                                        </div>
                                    </Col>
                                );
                            })
                        }
                    </>
                    :''
                }

                
            </Row>
            
        </div>

    );
}

export default UploadFactor;